import angular from 'angular';
import {
  loaderService,
  ssDialogService
} from 'app/services';
import schematics from '../schematics';
import workstations from '../workstations';
import servers from '../servers';
import controller from './edit-hardware-and-schematics-dialog.controller';
import template from './edit-hardware-and-schematics-dialog.html';


class dialogService {
  getOptions($event, {
    // eslint-disable-next-line no-shadow
    assessmentId, customerId, schematics, workstations, servers, hasNetComply, changedAssetCountCallback
  }) {
    return {
      controller,
      controllerAs: 'editHardwareAndSchematicsDialogVM',
      locals: {
        assessmentId,
        customerId,
        schematics,
        workstations,
        servers,
        hasNetComply,
        changedAssetCountCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editHardwareAndSchematicsDialog', [
  loaderService,
  schematics,
  servers,
  ssDialogService,
  workstations,
])
  .service('editHardwareAndSchematicsDialog', dialogService)
  .name;
